var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-spinner-content d-flex"},[_c('img',{staticClass:"ac-logo-spinner",attrs:{"src":require("../assets/ac-logo.png")}}),_c('h4',{staticClass:"spinner-h4"},[_vm._v("貼文正在努力載入中")])])
}]

export { render, staticRenderFns }